import Database from 'emoji-picker-element/database'
import { sequentially } from 'utilities/async'
import { prune, pruneBy } from 'utilities/array'

const emojiDatabase = new Database()
emojiDatabase.setPreferredSkinTone(0)

export const resolveEmoji = async emoji => {
    const resolved = await sequentially(emoji, async emoji => {
        if(!!emoji?.name && !!emoji?.emoji) {
            return emoji
        }

        if(!emoji?.name) {
            return null
        }

        const names = [
            emoji.name,
            emoji.name.replace(/-/g, '_'),
            emoji.name.replace(/_/g, '-'),
            emoji.name.replace(/_/g, ' '),
        ]

        names.push(...names.map(remapEmojiName))

        const rawMatches = await Promise.all(prune(names).flatMap(name => [
            emojiDatabase.getEmojiByShortcode(name),
            emojiDatabase.getEmojiBySearchQuery(name)
        ]))

        const matches = pruneBy(rawMatches.flat().filter(Boolean), 'unicode')//.sort((one, two) => one.order - two.order)

        const [match] = matches
        if(!match) {
            return null
        }

        return {
            ...match,
            name: emoji.name
        }
    })

    return resolved
        .filter(Boolean)
        .map(emoji => (emoji.unicode ? {
            name: emoji.name,
            emoji: emoji.unicode
        } : emoji))
}

export const resolveName = async emoji => {
    const resolved = await sequentially(emoji, async emoji => {
        if(!!emoji?.name && !!emoji?.emoji) {
            return emoji
        }

        if(!emoji?.emoji) {
            return null
        }

        const match = await emojiDatabase.getEmojiByUnicodeOrName(emoji.emoji)
        if(!match) {
            return null
        }

        return {
            ...match,
            name: match.shortcodes[0]
        }
    })

    return resolved
        .filter(Boolean)
        .map(emoji => (emoji.unicode ? {
            name: emoji.name,
            emoji: emoji.unicode
        } : emoji))
}

export const remapEmojiName = name => {
    if(name?.startsWith('flag-')) {
        return name.replace(/-/g, '_')
    }

    if(name?.match(/(male[-_])/)) {
        return name.replace(/^male/g, 'man')
    }

    if(name?.match(/(female[-_])/)) {
        return name.replace(/^female/g, 'woman')
    }

    return name
}